import { Restaurant } from 'src/app/models/restaurant.model';
import { OrderBuilder } from './../models/order.model';
import { DataService } from 'src/app/services/data.service';
import { Account, AccountBuilder } from 'src/app/models/account.model';
import { StateService } from 'src/app/services/state.service';
import {Component, OnInit, EventEmitter} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from "@angular/forms";
import {Cart, CartBuilder, CartItem} from "../models/cart.model";
import {Observable, of} from "rxjs";
import { Address, AddressBuilder } from "src/app/models/address.model";
import { Order } from "src/app/models/order.model";
import { DialogService } from '../services/dialog.service';
import { PaymentType } from '../models/payment.model';
import { Event, Router } from '@angular/router';
import { RestaurantBuilder } from '../models/restaurant.model';
import { HttpErrorResponse } from '@angular/common/http';
import { DeliveryType } from '../models/delivery_type.model';
import { Coupon, CouponType } from '../models/coupon.model';

@Component({
  selector: 'app-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.css']
})
export class OrderSummaryComponent implements OnInit {

  PaymentType = PaymentType;

  cart: Cart = new CartBuilder().build();
  order: Order = <Order>{};
  restaurant: Restaurant = <Restaurant>{};
  $cartItems: Observable<CartItem[]> = of();
  account: Account = new AccountBuilder().build();
  address: Address = new AddressBuilder().build();
  loading = false;

  isDelivery = true;
  isDeliveryAddressLoaded = false;
  isAddressFormOpened = false;
  isCustomAddress = true;
  isCouponLoaded = true;

  paymentFormGroup = new FormGroup({
    payment_type: new FormControl("2", [
      Validators.required
    ]),
  })

  deliveryFormGroup = new FormGroup({
    delivery_type: new FormControl("1", [
      Validators.required
    ]),
  })

  couponFormGroup = new FormGroup({
    coupon_name: new FormControl("", [

    ]),
  })

  deliveryAddresses = {};
  areaId = "";
  postcodes: string[] = [];
  cities: string[] = [];
  streets: string[] = [];


  // postcodeChange = new EventEmitter<any>();
  searchTerm: string = '';
  selectedItem: string | null = null;
  isPostcodeOpen: boolean = false;
  isCityOpen: boolean = false;
  isAddress1Open: boolean = false;

  accountFetched = new EventEmitter<Address>();
  restaurantFetched = new EventEmitter<Restaurant>();

  deliveryRateCalculated = false;

  PostcodeValidator(postcodes: string[]): any|null {
    return (control: FormControl) => {
      if (control.pristine)
        return null;

      let isValid = true;
      let val = control.value as string;
      let errors:ValidationErrors = {};

      if (/[0-9]{2}\-[0-9]{3}/.test(val) == false) {
        errors["invalid"] = true;
        return errors;
      }

      if (!postcodes.includes(val)) {
        isValid = false;
        errors["not-supported"] = true;
      }


      return isValid ? null: errors;
    }
  }

    CityValidator(cities: string[]): any|null {
    return (control: FormControl) => {
      if (control.pristine)
        return null;

      let isValid = true;
      let val = control.value as string;
      let errors:ValidationErrors = {};

      if (val.length < 2) {
        errors["invalid"] = true;
        return errors;
      }

      if (!cities.includes(val)) {
        isValid = false;
        errors["not-supported"] = true;
      }

      return isValid ? null: errors;
    }
  }

    Address1Validator(streets: string[]): any|null {
    return (control: FormControl) => {
      if (control.pristine)
        return null;

      let isValid = true;
      let val = control.value as string;
      let errors:ValidationErrors = {};

      if (val.length < 2) {
        errors["invalid"] = true;
        return errors;
      }


      if (!streets.includes(val)) {
        isValid = false;
        errors["not-supported"] = true;
      }

      return isValid ? null: errors;
    }
  }



  get filteredPostcodeOptions(): string[] {
    let postcode = this.addressFormGroup.get("postcode")?.value
    if (!postcode) {
      return this.postcodes;
    }

    return this.postcodes.filter(opt =>
      opt.includes(postcode)
    );
  }

  selectPostcode(option: string): void {
    this.isPostcodeOpen = false;
    this.addressFormGroup.get("postcode")?.setValue(option);

    this.onPostcodeChange();
  }


  get filteredCityOptions(): string[] {
    let city = this.addressFormGroup.get("city")?.value
    if (!city) {
      return this.cities;
    }

    return this.cities.filter(opt =>
      opt.toLowerCase().includes(city.toLowerCase())
    );
  }

  selectCity(option: string): void {
    this.isCityOpen = false;
    this.addressFormGroup.get("city")?.setValue(option);

    this.onCityChange();
  }

  get filteredAddress1Options(): string[] {
    let address1 = this.addressFormGroup.get("address1")?.value;
    if (!address1) {
      return this.streets;
    }

    return this.streets.filter(opt =>
      opt.toLowerCase().includes(address1.toLowerCase())
    );
  }

  selectAddress1(option: string): void {
    this.isAddress1Open = false;
    this.addressFormGroup.get("address1")?.setValue(option);

    this.onAddress1Change();
  }

  constructor(
    private state: StateService,
    private api: DataService,
    private dialog: DialogService,
    private router: Router,
  ) {
    let json = localStorage.getItem("cart") || null;
    this.cart = new CartBuilder().load(json);
    console.log(localStorage.getItem("order"));
    this.order = new OrderBuilder().load(localStorage.getItem("order") || null);
    console.log(this.order);
    if (this.cart !== null) {
      this.order.setCart(this.cart);
    }

    this.areaId = this.cart.AreaId;


    this.calculatePaymentFeeV2();
    this.paymentFormGroup.get("payment_type")?.setValue(this.order.PaymentType.toString());
    this.deliveryFormGroup.get("delivery_type")?.setValue(this.order.DeliveryType.toString());
    if (this.order.Address.Address1 !== '') {
      this.isCustomAddress = true;
      this.address = this.order.Address;
    }

    // this.calculateDeliveryFeeV2();

    this.$cartItems = new Observable<CartItem[]>(observer => {
      observer.next(this.cart.CartItems);
    });

  }

  addressFormGroup = new FormGroup({
    address1: new FormControl("", {
      validators: this.Address1Validator([]),
      updateOn: 'change'
    }),
    address2: new FormControl("", [
      Validators.required
    ]),
    address3: new FormControl("", []),
    city: new FormControl("", {
      validators: [this.CityValidator([])],
      updateOn: 'change'
    }),
    postcode: new FormControl("",
      {
        validators: [this.PostcodeValidator([])],
      }
    ),
    phone: new FormControl("",
      [
        Validators.required,
        Validators.minLength(9),
      ]
    )
  })




  ngOnInit(): void {
    this.city?.disable();
    this.address1?.disable();

    this.addressFormGroup.valueChanges.subscribe(() => {
      this.deliveryRateCalculated = false;
    })

    this.restaurantFetched.subscribe({
        next: () => {
          console.log("Fetched restaurant data");
          this.getDeliveryAddresses();
        }
    });

    this.accountFetched.subscribe({
        next: (account: any) => {
          console.log("Fetched account data");
          this.order.setAddress(account);
        }
    });


    if (this.order.DeliveryType == DeliveryType.COLLECTION_DELIVERY) {
      this.isDelivery = false;
      this.deliveryRateCalculated = false;
      this.getAccount();



    }

    if (this.order.DeliveryType == DeliveryType.HOME_DELIVERY) {
      this.isDelivery = true;
      this.getRestaurant();
    }

  }

  openForm() {
    this.isAddressFormOpened = true;
  }

  saveAddressForm() {
    let deliveryRate = this.restaurant.DeliveryRateV2;
    this.address = new AddressBuilder()
      .setAddress1(this.address1?.value)
      .setAddress2(this.address2?.value)
      .setAddress3(this.address3?.value)
      .setCity(this.city?.value)
      .setPostcode(this.postcode?.value)
      .setPhone(this.phone?.value)
      .build();

    deliveryRate = this.calculateDeliveryRate(this.address);

    this.order = new OrderBuilder()
      .setAddress(this.address)
      .setCart(this.cart)
      .setPayment(this.order.PaymentType)
      .setDelivery(this.order.DeliveryType)
      .setDeliveryFeeV2(deliveryRate)
      .setCoupon(this.order.Coupon)
      .build();
    localStorage.setItem("order", JSON.stringify(this.order.toJSON()));

    this.deliveryRateCalculated = true;

    console.log("address saved");
  }

  cancelForm() {
    this.isAddressFormOpened = false;
  }

  get address1() {
    return this.addressFormGroup.get('address1');
  }

  get address2() {
    return this.addressFormGroup.get('address2');
  }

  get address3() {
    return this.addressFormGroup.get('address3');
  }

  get city() {
    return this.addressFormGroup.get('city');
  }

  get postcode() {
    return this.addressFormGroup.get('postcode');
  }

  get phone() {
    return this.addressFormGroup.get('phone');
  }

  get couponName() {
    return this.couponFormGroup.get('coupon_name');
  }

  getAccount() {
    this.api.getAccount().subscribe({
      next: (account: Account) => {
        this.account = account;
        this.state.sendData(this.account);
        this.address = new AddressBuilder()
          .setAddress1(this.account.Address1)
          .setAddress2(this.account.Address2)
          .setAddress3(this.account.Address3)
          .setCity(this.account.City)
          .setPostcode(this.account.Postcode)
          .setPhone(this.account.Phone)
          .build();

        this.accountFetched.emit(this.address);
      },
      error: (err: Error) => {
        console.log(err);
        // TODO: display error
      },
      complete: () => {
        // TODO: close loader
      }
    })
  }


  createOrder() {
    let order = {
      cart: this.cart.toJSON(),
      address: this.address.toJSON(),
      note: '',
      payment_type: parseInt(this.paymentFormGroup.get("payment_type")?.value),
      delivery_type: parseInt(this.deliveryFormGroup.get("delivery_type")?.value),
      coupon_id: this.order.Coupon?.id,
    };

    this.loading = true;

    this.api.createOrder(order).subscribe({
      next: (data: any) => {

        if (data.status === 0) {
          this.loading = false;
          this.dialog.OpenErrorDialog({message: data.message});
        }

        if (order.payment_type === PaymentType.STRIPE_ONLINE_GLOBAL_PAYMENT) {
          if (data.status === 1 && data.url) {
            this.clearCart();
            window.location.href = data.url;
          }

        } else if (order.payment_type === PaymentType.CASH_PAYMENT) {
            if (data.status === 1) {
              this.clearCart();
              this.router.navigate(["/account"]);
            }



        } else if (order.payment_type === PaymentType.HOTPAY_ONLINE_GLOBAL_PAYMENT) {
          console.log("HOTPAY_ONLINE_GLOBAL_PAYMENT", data);
          console.log("HOTPAY_ONLINE_GLOBAL_PAYMENT", (data.status === 1 && data.hash && data.secret && data.total && data.description && data.www));
          if (data.status === 1 && data.url) {
            this.clearCart();
            window.location.href = data.url;
          }
        }




      },
      error: (err: HttpErrorResponse) => {
        // TODO
        console.log(err);
        this.loading = false;
        this.dialog.OpenErrorDialog({message: err.error?.message || err.message});
      },
      complete: () => {
        this.loading = false;
      }
    })

  }

  getRestaurant() {
    this.api.getRestaurant(new RestaurantBuilder("").setId(this.cart.RestaurantId).setAreaId(this.areaId).build()).subscribe({
      next: (restaurant: Restaurant) => {
        this.restaurant = restaurant;
        this.restaurantFetched.emit(this.restaurant);
      },
      error: (err: Error) => {
        console.log(err);
      },
      complete: () => {

      }
    })
  }

  getDeliveryAddresses() {
    this.api.getDeliveryAddresses(this.areaId).subscribe({
      next: (data: any) => {
        this.deliveryAddresses = data.area.addresses;


        this.isDeliveryAddressLoaded = true;

        this.postcodes = Object.keys(this.deliveryAddresses) || [];
        this.postcode?.setValidators([Validators.required, this.PostcodeValidator(this.postcodes)]);

        if (this.postcodes.includes(this.order.Address.Postcode)) {
          this.postcode?.setValue(this.order.Address.Postcode);

          this.cities = (this.deliveryAddresses as any)[this.postcode?.value].map((item: any)=> {return item.city});
          this.city?.setValidators([this.CityValidator(this.cities)]);
          this.city?.setValue(this.order.Address.City);
          this.city?.enable();

          if (this.cities.includes(this.city?.value)) {

            for (let i = 0; i < this.cities.length; i++) {
              let item = (this.deliveryAddresses as any)[this.postcode?.value][i];
              if (item.city == this.city?.value) {
                this.streets = item.streets;

                this.address1?.setValidators([this.Address1Validator(this.streets)]);
                this.address1?.enable();
                break;
              }
            }

            this.address1?.setValue(this.order.Address.Address1);
            this.address2?.setValue(this.order.Address.Address2);
            this.address3?.setValue(this.order.Address.Address3);
            this.phone?.setValue(this.order.Address.Phone)

            if (this.address1?.valid && this.phone?.valid) {
              this.order.setDeliveryFeeV2(this.calculateDeliveryRate(this.order.Address));
              this.saveAddressForm();
            }

            this.addressFormGroup.markAllAsTouched();
          }

        }




      },
      error: (err: any) => {

      }
    })
  }

  calculatePaymentFeeV2() {
    switch(this.order.PaymentType) {
      case PaymentType.STRIPE_ONLINE_GLOBAL_PAYMENT:
        // let fee = (1.00 * 10 + (this.cart.TotalPriceV2 * 0.04) * 10 + (this.order.DeliveryFeeV2 * 0.04) * 10) / 10;
        let fee = (this.cart.TotalPriceV2 * 0.04) + (this.order.DeliveryFeeV2 * 0.04);
        this.order.setPaymentFee(fee);
        this.order.setPaymentFeeV2(fee);
      break;
      case PaymentType.CASH_PAYMENT:
        this.order.setPaymentFee(0.00);
        this.order.setPaymentFeeV2(0);
      break;
      case PaymentType.HOTPAY_ONLINE_GLOBAL_PAYMENT:
        this.order.setPaymentFee(0.00);
        this.order.setPaymentFeeV2(0);
      break;
      }


  }

  calculateDeliveryFeeV2() {
    switch (this.order.DeliveryType) {
      case DeliveryType.HOME_DELIVERY:
        this.order.setDeliveryFeeV2(this.calculateDeliveryRate(this.order.Address));
        break;
      case DeliveryType.COLLECTION_DELIVERY:
        this.order.setDeliveryFee(0);
        this.order.setDeliveryFeeV2(0);
        break;
      }
  }

  calculateDeliveryRate(address: Address) {
    let deliveryRate = this.restaurant.DeliveryRateV2;

    if (this.restaurant.DeliveryRates == null)
      return deliveryRate;

    for (let i = 0; i < this.restaurant.DeliveryRates.length; i++) {
      let rate = this.restaurant.DeliveryRates[i];

      if (address.City == rate.city && address.Postcode == rate.postcode) {
        if (rate.street != "" && rate.street == address.Address1) {
          deliveryRate = rate.price;
          break;
        }

        if (rate.street == "") {
          deliveryRate = rate.price;
        }
      }
    }

    return deliveryRate;
  }

  setPaymentType(e: any) {
    let paymentType = e.target.value
    this.paymentFormGroup.get("payment_type")?.setValue(paymentType);
    this.order.setPayment(parseInt(paymentType));
    this.calculatePaymentFeeV2();

    localStorage.setItem("order", JSON.stringify(this.order.toJSON()));

  }

  setDeliveryType(e: any) {
    let deliveryType = parseInt(e.target.value);
    this.deliveryRateCalculated = false;
    this.isDeliveryAddressLoaded = false;

    this.deliveryFormGroup.get("delivery_type")?.setValue(deliveryType.toString());
    this.order.setDelivery(deliveryType);

    this.calculatePaymentFeeV2();

    if (deliveryType == DeliveryType.HOME_DELIVERY) {
      this.isDelivery = true;

      // this.calculateDeliveryFeeV2();
      this.order.setAddress(new AddressBuilder()
        .setAddress1(this.address1?.value)
        .setAddress2(this.address2?.value)
        .setAddress3(this.address3?.value)
        .setCity(this.city?.value)
        .setPostcode(this.postcode?.value)
        .setPhone(this.phone?.value)
        .build()
      );
      this.getRestaurant();

    }

    if (deliveryType == DeliveryType.COLLECTION_DELIVERY) {
      this.isDelivery = false;
      // this.deliveryRateCalculated = false;
      this.calculateDeliveryFeeV2();
      this.getAccount();
    }

    localStorage.setItem("cart", JSON.stringify(this.cart.toJSON()));
    localStorage.setItem("order", JSON.stringify(this.order.toJSON()));

  }

  clearCart() {
    localStorage.setItem("cart", "");
    localStorage.setItem("order", "");

    let cart = new CartBuilder().load(null);
    this.state.updateCart(cart);
    this.state.updateCartItems(cart.CartItems);
  }

  onPostcodeChange() {
    this.deliveryRateCalculated = false;
    this.city?.disable();
    this.city?.setValue("");

    this.address1?.disable();
    this.address1?.setValue("");

    let _postcode = this.postcode?.value;

    if (_postcode != null) {
      _postcode = _postcode.trim();
      this.postcode?.setValue(_postcode);

    }

    if (this.postcodes.includes(_postcode)) {
      this.cities = (this.deliveryAddresses as any)[_postcode].map((item: any)=> {return item.city});
      this.city?.enable();
      this.city?.setValidators([this.CityValidator(this.cities)]);
    }


  }

  onCityChange() {
    this.deliveryRateCalculated = false;
    let _postcode = this.postcode?.value;
    let _city = this.city?.value;

    if (_city != this.order.Address.City || _city == "" || _city == null) {
      this.address1?.disable();
      this.address1?.setValue("");
    }

    if (_city != null) {
      _city = _city.trim();
      this.city?.setValue(_city);
    }

    if (!this.cities.includes(_city))
      return;

    for (let i = 0; i < this.cities.length; i++) {
      let item = (this.deliveryAddresses as any)[_postcode][i];
      if (item.city == _city) {
        this.streets = item.streets;
        this.address1?.enable();
        break;
      }
    }

    this.address1?.setValidators(this.Address1Validator(this.streets));
  }

  onAddress1Change() {
    this.deliveryRateCalculated = false;
    let _address1 = this.address1?.value;

    if (_address1 != null) {
      _address1 = _address1.trim();
      this.address1?.setValue(_address1);
    }

    if (!this.streets.includes(_address1))
      return;

  }

  saveCouponForm() {
    this.isCouponLoaded = false;
    let coupon: Coupon = new Coupon();

    this.api.getCoupon((this.couponName?.value as string).toUpperCase().trim()).subscribe({
      next: (data: any) => {
        Object.assign(coupon, data.coupon);

        if (data.status != 1) {

          this.dialog.OpenErrorDialog({message: data.message});
          return;
        }

        console.log(data, this.restaurant);

        if ((coupon.valid_from * 1000) > Date.now() || (coupon.valid_to * 1000) < Date.now() ||
          (coupon.region != "" && coupon.region != this.cart.AreaId) ||
          (coupon.restaurant_id != "" && coupon.restaurant_id != this.cart.RestaurantId)
          /* this will be added once implemented in API and extended cart model to contain BusinessGroupId
          || (coupon.business_group_id != "" && coupon.business_group_id != this.restaurant.BusinessGroupId)*/) {
          this.dialog.OpenErrorDialog({message: `Kupon nieaktywny`});
          return;
        }

        this.order.setCoupon(coupon);
        localStorage.setItem("order", JSON.stringify(this.order.toJSON()));
      },
      error: (err) => {
        this.isCouponLoaded = true;
        console.log(err);
      },
      complete: () => {
        this.isCouponLoaded = true;
      }
    })

  }

  deleteCoupon() {
    if (this.order != null) {
      this.order.setCoupon(null);
      localStorage.setItem("order", JSON.stringify(this.order.toJSON()));

    }

  }
}

